import React, { useEffect, useState, useContext } from 'react';
import { PageContext } from '../context/page-context';

import { getIsGDPR } from '../utils/gdpr';

export default function LeadCap({
    block: {
        content: { title, description },
    },
}) {
    const profile = useContext(PageContext);
    const [isGDPR, setIsGDPR] = useState(true);
    const [email, setEmail] = useState(false);

    useEffect(() => {
        setIsGDPR(getIsGDPR() ?? true);
    }, [profile.geolocation]);

    function submit() {
        if (email) {
            window.location = `https://app.gettimely.com/register?email=${email}`;
        }
    }
    return (
        <div className="container u-vSpacingLG-top">
            <section className="guten-leadcap col-xs-12">
                <div className="container">
                    <form
                        onSubmit={submit}
                        action="https://app.gettimely.com/register"
                        className="tmly-lcf manual style-outline"
                        data-name="hplc"
                        data-mode="trial"
                        data-v="2">
                        <div className="row">
                            <div className="guten-leadcap-description col-12 col-xs-12 col-sm-12 col-md-6 col-lg-5 col-lg-offset-1">
                                <h3
                                    className="mbp5"
                                    dangerouslySetInnerHTML={{ __html: title }}
                                />
                                <p className="u-midGrey mb0">{description}</p>
                            </div>
                            <div className="col-12 col-xs-12 col-sm-10 offset-sm-1 col-sm-offset-1 offset-md-0 col-md-offset-0 col-md-6 col-lg-5">
                                <div className="row mb1">
                                    <div className="input col-8 col-xs-12 col-sm-8 col-md-8 col-lg-8 mt1 mbp5 leadcap-field-col">
                                        <input
                                            type="text"
                                            className="Input"
                                            name="email"
                                            placeholder="Email address"
                                            onChange={e => {
                                                setEmail(e.target.value);
                                            }}
                                            required
                                        />
                                    </div>
                                    <div className="input col-4 col-xs-12 col-sm-4 col-md-4 col-lg-4 mt1 mb2 leadcap-submit-col">
                                        <input
                                            className="button Button Button--primary crush granite"
                                            type="submit"
                                            defaultValue="Get started"
                                        />
                                    </div>
                                </div>

                                {/* <div className="row">
                                    <div className="check col-lg-12 mtp5 u-midGrey">
                                        <input
                                            type="checkbox"
                                            className="field tmly-field granite"
                                            defaultValue="yes"
                                            name="newsoffers"
                                        />
                                    </div>
                                </div> */}
                                <div className="row">
                                    <div className="mtp5 u-midGrey">
                                        <input
                                            className="field granite"
                                            defaultValue="Incomplete Sign-Up"
                                            name="source"
                                            hidden
                                        />
                                        <input
                                            className="field granite"
                                            defaultValue="Content"
                                            name="main-source"
                                            hidden
                                        />
                                        <input
                                            className="field granite"
                                            defaultValue="Content"
                                            name="sub-source"
                                            hidden
                                        />
                                    </div>
                                    <div className="col-lg-12">
                                        <label htmlFor="privacy" className="u-midGrey mt0">
                                            {isGDPR &&
                                                <span><input
                                                    type="checkbox"
                                                    className="field tmly-field granite"
                                                    defaultValue="yes"
                                                    id="privacy"
                                                    name="privacy"
                                                    required
                                                /> &nbsp;</span>
                                            }
                                            By providing your information you
                                            agree to our{' '}
                                            <a
                                                href="/support/privacy"
                                                target="_blank">
                                                privacy policy
                                            </a>
                                            {isGDPR && ', and agree to receive Timely news and marketing offers.'}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    );
}
